<template>
  <div class="white-bg" v-loading="loading">
    <div class="flex flex-h-bet">
      <h3 class="bold mt-0 mb-20">Reports</h3>
    </div>

    <div class="filters no-check mt-50 relative m-30">
      <div class="mb-20 bold flex flex-h-bet">
        <p style="text-transform: capitalize">{{ reportParams.type }} Report</p>
        <div class="btn-wrapper mb-10 move-right">
          <div
            class="inline-flex flex-v-end mr-10 ml-10"
            v-if="reportsData.length"
          >
            <el-select
              v-model="selectedFormat"
              placeholder="Export As"
              class="repo-select export"
              @change="downloadReport"
              clearable
            >
              <el-option
                v-for="item in downloadFormats"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>
          <button
            @click.prevent="$router.go(-1)"
            class="btn btn-full-radius ml-10 report-clear"
          >
            Clear
          </button>
        </div>
      </div>
      <div class="mb-20">
        <p class="bold mb-10">Date Filter</p>
        <span class="block-text">
          {{ reportParams.date_from }} <span class="bold">to</span>
          {{ reportParams.date_to }}
        </span>
      </div>
    </div>

    <div>
      <ReportDetailView
        :showDetail="showDetail"
        @toggleView="toggleView"
        :reportDetail="reportDetail"
      />
      <SimpleReportTable
        v-if="reportParams.type === 'simple'"
        :reports="reportsData"
        :groupby="`employee`"
        :loading="loading"
        @toggleView="toggleView"
      />
      <LogReportTable
        v-else-if="reportParams.type === 'logs'"
        :reports="reportsData"
        :groupby="`employee`"
        :loading="loading"
      />
      <LatenessReportTable
        v-else-if="reportParams.type === 'lateness'"
        :reports="reportsData"
        :groupby="`employee`"
        :loading="loading"
      />
      <WorkforceReportTable
        v-else-if="reportParams.type === 'workforce'"
        :reports="reportsData"
        :groupby="`employee`"
        :loading="loading"
        @toggleView="toggleView"
      />
      <AbsenteeReportTable
        v-else-if="reportParams.type === 'absentee'"
        :reports="reportsData"
        :groupby="`employee`"
        :loading="loading"
      />
      <PunctualityReportTable
        v-else-if="reportParams.type === 'punctuality'"
        :reports="reportsData"
        :groupby="`employee`"
        :loading="loading"
      />
      <SummaryReportTable
        v-else-if="reportParams.type === 'summary'"
        :reports="reportsData"
        :groupby="reportParams.group_by"
        :loading="loading"
      />
      <EarlyInReportTable
        v-else-if="reportParams.type === 'earlyIn'"
        :reports="reportsData"
        :groupby="`employee`"
        :loading="loading"
      />
      <OffDayReportTable
        v-else-if="reportParams.type === 'offday'"
        :reports="reportsData"
        :groupby="`employee`"
        :loading="loading"
      />
      <div v-else>Report Type {{ reportParams.type }} not Supported.</div>
    </div>
  </div>
</template>

<script>
import { tableFormatter } from "@/helpers/functions";

import SimpleReportTable from "../../../../Admin/attendance/reports/components/SimpleReportTable";
import LatenessReportTable from "../../../../Admin/attendance/reports/components/LatenessReportTable";
import WorkforceReportTable from "../../../../Admin/attendance/reports/components/WorkforceReportTable";
import AbsenteeReportTable from "../../../../Admin/attendance/reports/components/AbsenteeReportTable";
import PunctualityReportTable from "../../../../Admin/attendance/reports/components/PunctualityReportTable";
import SummaryReportTable from "../../../../Admin/attendance/reports/components/SummaryReportTable";
import LogReportTable from "../../../../Admin/attendance/reports/components/LogReportTable";
import EarlyInReportTable from "../../../../Admin/attendance/reports/components/EarlyInReportTable";
import OffDayReportTable from "../../../../Admin/attendance/reports/components/OffDayReportTable";
import ReportDetailView from "../../../../Admin/attendance/reports/components/ReportDetailView";

export default {
  components: {
    SimpleReportTable,
    LatenessReportTable,
    WorkforceReportTable,
    AbsenteeReportTable,
    PunctualityReportTable,
    SummaryReportTable,
    LogReportTable,
    EarlyInReportTable,
    OffDayReportTable,
    ReportDetailView,
  },

  data() {
    return {
      loading: false,
      reportParams: {},
      reportsData: [],
      reportsTotal: null,
      showTable: false,
      selectedFormat: "",
      pageSizes: this.$store.state.admin.pageSizes,
      downloadFormats: this.$store.state.admin.downloadFormats,
      selectedRows: [],
      reportDetail: {},
      showDetail: false,
    };
  },
  computed: {},

  mounted() {
    this.reportParams = this.$route.params.reportParams;

    if (!this.reportParams || Object.keys(this.reportParams).length <= 0) {
      this.$router.push("/ess/attendance/reports/generate");
      this.$notification.error(
        "Please select filters to generate attendance report."
      );
      return;
    }

    this.getEssAttendanceReport();
  },

  methods: {
    tableFormatter,
    toggleView(row) {
      if (!row) {
        this.showDetail = false;
        return;
      }
      this.showDetail = !this.showDetail;
      this.reportDetail = row;
    },
    handleSelectionChange(val) {
      this.selectedRows = val;
    },

    getEssAttendanceReport() {
      this.loading = true;

      this.$store
        .dispatch(
          "admin/attendance/reports/getEssAttendanceReport",
          this.reportParams
        )
        .then(response => {
          this.loading = false;
          this.reportsData = response.data.results;
          this.reportsTotal = response.data.total;
        })
        .catch(error => {
          this.loading = false;
          this.$notification.error(error.message);
        });
    },

    downloadReport() {
      const format = this.selectedFormat;

      if (format === null || format === "") {
        return false;
      }
      this.loading = true;

      this.$store
        .dispatch("admin/attendance/reports/downloadEssReport", {
          ...this.reportParams,
          format,
        })
        .then(response => {
          const link = document.createElement("a");
          link.href = `${this.$config.get("VUE_APP_DOWNLOAD_URL")}${
            response.data
          }`;
          link.download = response.data;
          link.click();
          this.loading = false;
        })
        .catch(error => {
          this.$notification.error(error.message);
          this.loading = false;
        });
    },
  },
};
</script>
<style scoped></style>
